import CreatorPaymentHistoryPage from "./CreatorPaymentHistoryPage";

export default CreatorPaymentHistoryPage;
